// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Fotm","overflowing":"ReadFullNote_overflowing__1F-ms"};